import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    container:{
        paddingTop:'3px',
        paddingLeft:'3px',
        paddingRight:'3px',
        height:'20px',
        fontSize:10,
        flexDirection: 'row',
        fontWeight:'normal',
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    text:{
        fontSize: 10,
        whiteSpace: 'pre-line'
    }
});

const ProposalCondition = ({title, value}) => (  
   <>
        <Text style={styles.reportTitle}>{title}</Text>
        <View style={styles.container}>
            <Text>{value}</Text>
        </View>
   </>
);
  
export default ProposalCondition